module.exports = __webpack_public_path__ + "static/media/mt-ut-img-14.902d3a41.webp";